import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllBodySite,
  GetAllClaimPreAuthAllList,
  GetAllCommunicationHistory,
  GetAllEncounterClass,
  GetAllEncounterInfo,
  GetAllNationality,
  GetAllPractitonerList,
  GetAllPreauthorizationList,
  GetAllPreauthorizationStatus,
  GetAllPreauthorizationType,
  GetAllProviderName,
  GetAllRoute,
  GetAllSpecilaity,
  GetHistoryLogs,
  GetItemError,
  GetMissingTooth,
  GetPreauthorizationCancelResponse,
  GetPreauthorizationEligibility,
  GetPreauthorizationRequest,
  GetPreauthorizationResponse,
  GetSpecialityPractitonerList,
  ViewPreauthorization,
  ViewPreauthorizationHistoryLog,
} from "./preauthorizationApi";
import { getToday } from "helpers/utils";

const preauthorizationSlice = createSlice({
  name: "preauthorization",
  initialState: {
    preauthorizationDiagnosis: [],
    stepFormData: null,
    historyModalOpen: false,
    viewModal: false,
    selectedService: null,
    servicesList: [],
    discharegSpeciality: [],
    admissionSpeciality: [],
    preauthorizationNotes: [],
    preauthorizationList: [],
    selectedToothInfo: null,
    nationalityPreList: [],
    selectedToothInfo: null,
    servicesErrorList: [],
    preauthorizationType: [],
    preauthorizationSubType: [],
    preauthorizationFilters: {
      payer: "",
      insurance: "",
      patient: "",
      start_date: getToday(),
      end_date: getToday(),
      reference_number: "",
      preauthorization_type: "",
      preauthorization_sub_type: "",
      preauthid: '',
      identity_type: "",
      identity_number: "",
      preauthorization_status: "",
      secondary_response: false,
      communication: false,
      advanced_authorization: false,
    },
    preauthorizationStatus: [],
    visitReasons: [],
    encounterClass: [],
    serviceTypeList: [],
    actPeriortyList: [],
    triageCategoryList: [],
    emergencyArrivalList: [],
    departmentDispositionList: [],
    lengthOfStayList: [],
    encounterStatusList: [],
    adminResourceList: [],
    dischargeDispositionList: [],
    reAdmissionList: [],
    eventTypeList: [],
    processPriority: [],
    practitionerListAdded: [],
    communcationDetails: [],
    diagnosisiList: [],
    conditionOnset: [],
    accidentType: [],
    practitionerList: [],
    serviceTypeList: [],
    specialityList: [],
    labTestList: [],
    validationErrors: [],
    validationWarning: [],
    bodySite: [],
    oralDentalList: [],
    selectReasonList: [],
    investgationList: [],
    errorItemMessage: [],
    serviceTypeListEncounter: [],
    viewPreauthorizationInfo: null,
    viewEligibility: null,
    preauthorizationHistoryLog: [],
    viewPayerRes: null,
    viewPayerReq: null,
    viewCancelRes: null,
    preauthorizationEligibility: null,
    preauthorizationResponse: null,
    preauthorizationCancelResponse: null,
    preauthorizationRequest: null,
    communicationHistoryList: [],
    substituteReason: [],
    missingTeethList: [],
    providerName: [],
    doseList: [],
    durationList: [],
    practitionerRoleList: [],
    missingTeethListReason: [],
    bodySubSite: [],
    scientificAbsnceReason: [],
    cancelReasonList: [],
    routeList: [],
  },
  reducers: {
    setHistoryModal: (state, action) => {
      state.historyModalOpen = action?.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    handlePreauthorizationFilter: (state, action) => {
      state.preauthorizationFilters[action?.payload?.check] =
        action?.payload?.value;
    },
    handleResetPreauthorizationFilter: (state, { payload }) => {
      state.preauthorizationFilters = {
        payer: "",
        insurance: "",
        patient: "",
        start_date: getToday(),
        end_date: getToday(),
        reference_number: "",
        preauthorization_type: "",
        preauthorization_sub_type: "",
        identity_type: "",
        identity_number: "",
        preauthorization_status: "",
        secondary_response: false,
        communication: false,
        advanced_authorization: false,
      };
    },
    resetSelectedService: (state) => {
      state.selectedService = null;
    },
    setViewModal: (state, action) => {
      state.viewModal = action.payload;
    },
    addValidationError: (state, action) => {
      const exists = state.validationErrors.some(
        (error) => error.message === action.payload.message
      );
      if (!exists) {
        state.validationErrors.push(action.payload);
      }
    },
    addValidationWarning: (state, action) => {
      const exists = state.validationWarning.some(
        (error) =>
          error.message === action.payload.message &&
          error.code === action.payload.code
      );
      if (!exists) {
        state.validationWarning.push({
          code: action.payload.code,
          message: action.payload.message,
        });
      }
    },
    removeValidationWarningByCode: (state, action) => {
      state.validationWarning = state.validationWarning.filter(
        (warning) => warning.code !== action.payload
      );
    },

    clearValidationWarning: (state) => {
      state.validationWarning = [];
    },
    clearValidationErrors: (state) => {
      state.validationErrors = [];
    },
    removeValidationError: (state, action) => {
      state.validationErrors = state.validationErrors.filter(
        (error) => error.field !== action.payload
      );
    },
    resetPreauthCancel: (state, _) => {
      state.preauthorizationCancelResponse = null;
      state.viewCancelRes = null;
    },
    handleAddPreauthorizationNotes: (state, action) => {
      const { type, payload } = action.payload;
      if (type === "add") {
        state.preauthorizationNotes.push({
          id: Date.now(),
          ...payload,
        });
      } else if (type === "delete") {
        state.preauthorizationNotes = state.preauthorizationNotes.filter(
          (item) => item.id !== payload.id
        );
      }
    },
    handleAddPractitionerList: (state, action) => {
      const { type, payload } = action.payload;

      switch (type) {
        case "add":
          const exists = state.practitionerListAdded.some(
            (p) =>
              p.practitioner?.value?.practitioner_id ===
              payload.practitioner?.value?.practitioner_id
          );
          if (!exists) {
            state.practitionerListAdded.push({
              id:
                payload.practitioner?.value?.practitioner_id ||
                new Date().getTime(),
              practitioner: payload.practitioner || null,
              practice: payload.practice || null,
              role: payload.role || null,
              specialties: payload.specialties || [],
              originalSpecialties: payload.specialties || [],
            });
          }
          break;

        // Add this new case for bulk insertion
        case "addMultiple":
          payload.forEach((practitioner) => {
            state.practitionerListAdded.push({
              id: practitioner.id || new Date(),
              practitioner: practitioner.practitioner || null,
              practice: practitioner.practice || null,
              role: practitioner.role || null,
              specialties: practitioner.specialties || [],
              originalSpecialties:
                practitioner.originalSpecialties ||
                practitioner.specialties ||
                [],
            });
          });
          break;

        case "delete":
          if (payload?.id) {
            state.practitionerListAdded = state.practitionerListAdded.filter(
              (p) => p.id !== payload.id
            );
          }
          break;

        case "update":
          if (payload?.id) {
            const index = state.practitionerListAdded.findIndex(
              (p) => p.id === payload.id
            );
            if (index !== -1) {
              state.practitionerListAdded[index] = {
                ...state.practitionerListAdded[index],
                ...payload,
                specialties:
                  payload.specialties ||
                  state.practitionerListAdded[index].specialties,
              };
            }
          }
          break;

        case "updateField":
          if (payload?.id && payload?.field) {
            const rowIndex = state.practitionerListAdded.findIndex(
              (p) => p.id === payload.id
            );
            if (rowIndex !== -1) {
              state.practitionerListAdded[rowIndex] = {
                ...state.practitionerListAdded[rowIndex],
                [payload.field]: payload.value,
                ...(payload.field === "practitioner" && {
                  practice: null,
                  specialties: payload.value?.specialties || [],
                }),
              };
            }
          }
          break;

        case "updateSpecialties":
          if (payload?.id) {
            const rowIndex = state.practitionerListAdded.findIndex(
              (p) => p.id === payload.id
            );
            if (rowIndex !== -1) {
              state.practitionerListAdded[rowIndex].specialties =
                payload.specialties ||
                state.practitionerListAdded[rowIndex].originalSpecialties;
            }
          }
          break;

        default:
          console.warn("Unknown action type:", type);
          break;
      }
    },

    selectedTooth: (state, action) => {
      state.selectedToothInfo = action.payload;
    },
    handleAddPreauthorizationServices: (state, action) => {
      const { type, payload } = action.payload;

      if (type === "ADD_SERVICES") {
        const isDuplicate = state.servicesList.some(
          (service) => service.id === payload.id
        );

        if (!isDuplicate) {
          state.servicesList.push({
            id: payload?.id || Date.now(),
            ...payload,
          });
        } else {
        }
      } else if (type === "EDIT_SERVICES") {
        const index = state.servicesList.findIndex(
          (item) => item.id === payload.id
        );
        if (index !== -1) {
          state.servicesList[index] = {
            ...state.servicesList[index],
            ...payload,
          };
        }
      } else if (type === "DELETE_SERVICES") {
        state.servicesList = state.servicesList.filter(
          (item) => item?.id !== payload?.id
        );
      }

      // (Optional) Remove GET - it doesn't do anything currently
    },

    handlePreauthFormData: (state, action) => {
      const { check, data, key, value } = action.payload;

      if (check === "save") {
        state.stepFormData = {
          ...state.stepFormData,
          ...data,
        };
      } else if (check === "edit") {
        state.stepFormData = {
          ...state.stepFormData,
          [key]: value,
        };
      }
    },

    handleResetAll: (state, action) => {
      const { check } = action?.payload;
      if (check === "reset") {
        state.stepFormData = null;
        state.historyModalOpen = false;
        state.viewModal = false;
        state.selectedService = null;
        state.serviceTypeList = null;
        state.practitionerListAdded = [];
        state.diagnosisiList = [];
        state.labTestList = [];
        state.preauthorizationDiagnosis = [];
        state.validationErrors = [];
        state.selectedToothInfo = null;
        state.servicesList = [];
        state.validationWarning = [];
        state.viewPreauthorizationInfo = null;
        state.viewEligibility = null;
        state.viewPayerRes = null;
        state.viewPayerReq = null;
        state.viewCancelRes = null;
        state.preauthorizationEligibility = null;
        state.errorItemMessage = [];
        state.preauthorizationResponse = null;
        state.preauthorizationRequest = null;
        state.servicesErrorList = [];
        state.preauthorizationCancelResponse = null;
      }
    },

    handleResetHistoryLogs: (state, _) => {
      state.preauthorizationHistoryLog = [];
    },

    handleAddLabTest: (state, action) => {
      const { type, payload } = action?.payload;

      if (type === "ADDLABTEST") {
        const isDuplicate = state.labTestList.some(
          (lab) =>
            lab.lab_test_code?.loinc_code === payload.lab_test_code?.loinc_code
        );

        if (!isDuplicate) {
          state.labTestList.push({
            id: payload?.id || Date.now(),
            ...payload,
          });
        } else {
        }
      }
    },

    handleDeleteLabTest: (state, action) => {
      const {
        payload: { id },
      } = action;
      state.labTestList = state.labTestList.filter((item) => item.id !== id);
    },
    handlePreauthorizationDiagnosis: (state, action) => {
      const { type, payload } = action.payload;
      if (type === "set") {
        state.preauthorizationDiagnosis = payload;
      }

      if (type === "add") {
        // ✅ Prevent duplicates based on code + type + description
        const isDuplicate = state.preauthorizationDiagnosis.some(
          (item) =>
            item.code === payload.code &&
            item.type === payload.type &&
            item.description?.toLowerCase() ===
            payload.description?.toLowerCase()
        );

        if (!isDuplicate) {
          state.preauthorizationDiagnosis.push({
            id: Date.now(), // generate unique id
            date: payload.date,
            type: payload.type,
            code: payload.code,
            description: payload.description,
            condition_onset: payload.condition_onset,
            level: payload?.level,
            effective_from: payload?.effective_from,
            inactive: payload?.inactive,
            reactivated: payload?.reactivated,
            sex: payload?.sex,
            Stype: payload?.Stype,
            AgeL: payload?.AgeL,
            AgeH: payload?.AgeH,
            Atype: payload?.Atype,
            onAdmission: payload?.onAdmission,
            RDiag: payload?.RDiag,
            Morph_Code: payload?.Morph_Code,
            RTA_diag: payload?.RTA_diag,
            concept_change: payload?.concept_change,
            UnacceptPDx: payload?.UnacceptPDx,
          });
        } else {
        }
      } else if (type === "update") {
        const { id, field, value } = payload;
        const index = state.preauthorizationDiagnosis.findIndex(
          (item) => item.id === id
        );
        if (index !== -1) {
          state.preauthorizationDiagnosis[index][field] = value;
        }
      } else if (type === "delete") {
        const { id } = payload;
        state.preauthorizationDiagnosis =
          state.preauthorizationDiagnosis.filter((item) => item.id !== id);
      }
    },
    setErrorServices: (state, action) => {
      const message = action?.payload; // because you wrapped payload inside an object
      if (message && !state.servicesErrorList.includes(message)) {
        state.servicesErrorList.push(message);
      }
    },

    setLabTests: (state, action) => {
      state.labTestList = action.payload;
    },
    handleResetHistoryLog: (state, action) => {
      state.preauthorizationHistoryLog = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPreauthorizationType.fulfilled, (state, action) => {
        state.preauthorizationType = action.payload?.data?.claim_type;
        state.preauthorizationSubType = action.payload?.data?.claimsub_type;
      })
      .addCase(GetAllPreauthorizationStatus.fulfilled, (state, action) => {
        state.preauthorizationStatus = action.payload?.data?.allstatus_data;
      })
      .addCase(GetAllPreauthorizationList.fulfilled, (state, action) => {
        state.preauthorizationList = action?.payload?.data?.preauth_data;
      })
      .addCase(GetAllClaimPreAuthAllList.fulfilled, (state, action) => {
        state.visitReasons = action?.payload?.data?.visit_reasons;
        state.processPriority = action?.payload?.data?.process_priority;
        state.diagnosisiList = action?.payload?.data?.diagnosis_type;
        state.conditionOnset = action?.payload?.data?.cond_onset;
        state.accidentType = action?.payload?.data?.accident_type;
        state.serviceTypeList = action?.payload?.data?.service_type;
        state.scientificAbsnceReason =
          action?.payload?.data?.scientific_absnce_reason;
        state.selectReasonList = action?.payload?.data?.pharmacy_select_reason;
        state.substituteReason =
          action?.payload?.data?.pharmacy_substitute_reason;
        state.investgationList = action?.payload?.data?.investreslt_type;
        state.practitionerRoleList = action?.payload?.data?.practitioners_roles;
        state.doseList = action?.payload?.data?.ucum_type;
        state.durationList = action?.payload?.data?.unit_time;
        state.cancelReasonList = action?.payload?.data?.cancel_reason;
        state.communcationDetails =
          action?.payload?.data?.communication__details;
      })
      .addCase(GetAllPractitonerList.fulfilled, (state, action) => {
        state.practitionerList = action.payload?.data?.practitioner;
      })
      .addCase(GetAllNationality.fulfilled, (state, action) => {
        state.nationalityPreList = action?.payload?.data?.nationality;
      })
      .addCase(GetSpecialityPractitonerList.fulfilled, (state, action) => {
        state.specialityList = action.payload?.data?.speciality;
      })
      .addCase(GetAllBodySite.fulfilled, (state, action) => {
        state.bodySite = action.payload?.data?.body_site;
        state.bodySubSite = action.payload?.data?.body_sub_site;
        state.missingTeethList = action?.payload?.data?.body_site_dental;
        state.oralDentalList = action?.payload?.data?.body_site_dental;
      })
      .addCase(GetAllEncounterClass.fulfilled, (state, action) => {
        state.encounterClass = action.payload?.data?.Encounter_Class;
      })
      .addCase(GetAllSpecilaity.fulfilled, (state, action) => {
        state.discharegSpeciality = action.payload?.data?.speciality;
        state.admissionSpeciality = action.payload?.data?.speciality;
      })
      .addCase(GetAllProviderName.fulfilled, (state, action) => {
        state.providerName = action.payload?.data?.nphies_provider;
      })
      .addCase(GetHistoryLogs.fulfilled, (state, action) => {
        state.preauthorizationHistoryLog =
          action?.payload?.data?.preauth_histry;
      })
      .addCase(GetAllRoute.fulfilled, (state, action) => {
        state.routeList = action?.payload?.data?.pharmacy_route_admin;
      })
      .addCase(ViewPreauthorization.fulfilled, (state, action) => {
        state.viewPreauthorizationInfo = action?.payload?.data;
        state.viewEligibility =
          action?.payload?.data?.eligibility_response_path;
        state.viewPayerReq = action?.payload?.data?.preauth_request_path;
        state.viewPayerRes = action?.payload?.data?.preauth_response_path;
        state.viewCancelRes = action?.payload?.data?.preauth_cncl_response_path;
      })
      .addCase(GetAllEncounterInfo.fulfilled, (state, action) => {
        state.serviceTypeListEncounter = action?.payload?.data?.service_type;
        state.actPeriortyList = action?.payload?.data?.act_priority;
        state.triageCategoryList = action?.payload?.data?.triage_category;
        state.emergencyArrivalList = action?.payload?.data?.emergency_arrival;
        state.departmentDispositionList =
          action?.payload?.data?.department_disposition;
        state.lengthOfStayList = action?.payload?.data?.length_ofstay;
        state.encounterStatusList = action?.payload?.data?.status;
        state.adminResourceList = action?.payload?.data?.admin_resource;
        state.dischargeDispositionList =
          action?.payload?.data?.discharge_disposition;
        state.reAdmissionList = action?.payload?.data?.re_admission;
        state.eventTypeList = action?.payload?.data?.event_type;
      })
      .addCase(GetPreauthorizationEligibility.fulfilled, (state, action) => {
        state.preauthorizationEligibility = action?.payload;
      })
      .addCase(GetPreauthorizationRequest.fulfilled, (state, action) => {
        state.preauthorizationRequest = action?.payload;
      })
      .addCase(GetPreauthorizationResponse.fulfilled, (state, action) => {
        state.preauthorizationResponse = action.payload;
      })
      .addCase(GetPreauthorizationCancelResponse.fulfilled, (state, action) => {
        state.preauthorizationCancelResponse = action.payload;
      })
      .addCase(GetMissingTooth.fulfilled, (state, action) => {
        state.missingTeethListReason = action?.payload?.data?.missing_tooth;
      })
      .addCase(GetItemError.fulfilled, (state, action) => {
        state.errorItemMessage = action?.payload?.data?.error_code;
      })
      .addCase(ViewPreauthorizationHistoryLog.fulfilled, (state, action) => {
        state.viewPreauthorizationInfo = action?.payload?.data;
      })
      .addCase(GetAllCommunicationHistory.fulfilled, (state, action) => {
        state.communicationHistoryList =
          action.payload?.data?.communication_details;
      });
  },
});

export const {
  handlePreauthorizationDiagnosis,
  handlePreauthFormData,
  handleAddPreauthorizationNotes,
  setHistoryModal,
  setSelectedService,
  addValidationError,
  clearValidationErrors,
  handleResetHistoryLog,
  selectedTooth,
  removeValidationError,
  clearValidationWarning,
  addValidationWarning,
  setValidateError,
  handleResetAll,
  setErrorServices,
  resetPreauthCancel,
  handleResetPreauthorizationFilter,
  removeValidationWarningByCode,
  handlePreauthorizationFilter,
  resetSelectedService,
  handleAddPreauthorizationServices,
  handleAddLabTest,
  setLabTests,
  handleResetHistoryLogs,
  handleAddPractitionerList,
  handleDeleteLabTest,
  setViewModal,
} = preauthorizationSlice.actions;

export default preauthorizationSlice.reducer;
